module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA4SURBVHgB7dIxEQAgEAPBBBF4RBEeMfFAgQJo+LltEgEnIT2fExF9TdUbw3bbpwjpURHuURE+MAFBrw8K1hcJrQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/top-bar-expand.png
// module id = 2677
// module chunks = 0